import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MercadoPagoService } from '../../services/mercadopago/mercadopago.service';
import { ToastService } from '../../services/toast/toast.service';
import { TEXT_CONSTANTS } from '../../constants/text-constants';

/** Shows a transaction's Mercado Pago counterparty id and lets the user set its alias inline. */
@Component({
  selector: 'mp-counterparty-alias',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './mp-counterparty-alias.component.html'
})
export class MpCounterpartyAliasComponent {
  @Input() mpCounterpartyId?: string | null;

  readonly MP = TEXT_CONSTANTS.SETTINGS.INTEGRATIONS.MERCADOPAGO.CONTACTS;
  readonly COMMON = TEXT_CONSTANTS.COMMON;

  private _mpService = inject(MercadoPagoService);
  private _toastService = inject(ToastService);

  editingAlias = false;
  savingAlias = false;
  aliasDraft = '';

  get mpAlias(): string {
    return this._mpService.getContact(this.mpCounterpartyId)?.alias || '';
  }

  startEditAlias(): void {
    this.aliasDraft = this.mpAlias;
    this.editingAlias = true;
  }

  saveAlias(): void {
    const mpId = this.mpCounterpartyId;
    if (!mpId || this.savingAlias) return;
    this.savingAlias = true;
    this._mpService.saveAlias(mpId, this.aliasDraft.trim()).subscribe({
      next: () => {
        this.savingAlias = false;
        this.editingAlias = false;
        this._toastService.success(this.MP.SAVE_SUCCESS);
      },
      error: (err) => {
        this.savingAlias = false;
        this._toastService.error(this._toastService.getErrorDetail(err, this.MP.SAVE_ERROR));
      }
    });
  }
}
